import { useEffect, useState } from "react";
import { useFetchPathNormativitiesQuery } from "../../../api/rtk/base/slices/diagnosticsApiSlice";
import { Loader } from "../../loaders/Loader";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { Box, LinearProgress, LinearProgressProps, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ToastMessageContainer from "../../toastMessageContainer/ToastMessageContainer";
import { useDispatch } from "react-redux";
import { setToastMessageContainerClearButtonIsClicked, showToastMessage } from "../../../stateManagement/reducers";

export const measureTypesNames: any = {
    'Roughness': 'Продольная ровность покрытия',
    'Defects': 'Состояние покрытия',
    'GaugeDepth': 'Поперечная ровность (колейность)',
    'Strength': 'Прочность дорожной одежды',
    'Cohesion': 'Коэффициент сцепления'
}

export const shortMeasureTypesNames: any = {
    'Roughness': 'Ровность',
    'Defects': 'Дефекты',
    'GaugeDepth': 'Колейность',
    'Strength': 'Прочность',
    'Cohesion': 'Сцепление',
    'Total': 'Все показатели'
}

// Компонент - содержимое вкладки Диагностика -> Участки диагностики
export function DiagnosticsPathNormativitiesSection() {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const chosenYear = useAppSelector(state => state.diagnosticsPathNormativities.yearInfo)
    const [isSmallWindow, setIsSmallWindow] = useState(false);
    const roadFilter = useAppSelector(state => state.diagnosticsPathNormativities.pathNormativitiesSearchValue)
    let filterStringArray = [`DiagnosticYear eq ${chosenYear}`]
    if (roadFilter) {
        filterStringArray.push(`position('${roadFilter}', PathRoadName) gt 0 or position('${roadFilter}', PathDescription) gt 0`)
    }
    function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant="determinate" {...props} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2">{`${props.value}%`}</Typography>
                </Box>
            </Box>
        );
    }

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallWindow(contentHeaderWidth < 734);
    }, [sideBarState, navigate])

    const {
        data: pathNormativities,
        isFetching: pathNormativitiesAreFetching,
        isError: errorPathNormativities
    } = useFetchPathNormativitiesQuery({ filterStringArray: filterStringArray })

    useEffect(() => {
        if (pathNormativitiesAreFetching) {
            dispatch(setToastMessageContainerClearButtonIsClicked(true))
        }
    }, [pathNormativitiesAreFetching])

    useEffect(() => {
        if (errorPathNormativities) {
            dispatch(showToastMessage({ messageText: 'Не удалось загрузить нормативности', messageType: "error" }))
        }
    }, [errorPathNormativities])

    return (
        <>
            <ToastMessageContainer />
            {(pathNormativitiesAreFetching)
                ?
                <Loader />
                :
                <>
                    {errorPathNormativities ? <></>
                        :
                        <>
                            {pathNormativities.value.length > 0
                                ?
                                <>
                                    {pathNormativities.value.map((item: any) => {
                                        return (
                                            <>
                                                {isSmallWindow
                                                    ?
                                                    <>
                                                        <div className="section-name">
                                                            <span>{item.PathRoadName}, {item.PathDescription}, протяжённость: {item.TotalLength && item.TotalLength?.toFixed(3)} км</span>
                                                        </div>
                                                        {Object.keys(measureTypesNames).map((key: any) => {
                                                            return (
                                                                <div className="mobile-section-content">
                                                                    <div className="values">
                                                                        <strong className="mobile-measure-name">{measureTypesNames[key]}</strong>
                                                                        {item[`${key}Total`] !== null
                                                                            ?
                                                                            <span className="mobile-measure-distance">Обследовано: {item[`${key}Total`]?.toFixed(3)} км</span>
                                                                            :
                                                                            <span className="mobile-measure-distance">Обследовано: 0 км</span>
                                                                        }
                                                                        <span className="normativity-label">В нормативе: </span>
                                                                        {item[`${key}AdmissiblePercent`] !== null
                                                                            ?
                                                                            <div className="progress-bar-div-for-small">
                                                                                <Box sx={{ width: '100%' }}>
                                                                                    <LinearProgressWithLabel className="bar" value={item[`${key}AdmissiblePercent`]?.toFixed(1)} />
                                                                                </Box>
                                                                            </div>
                                                                            :
                                                                            <p>Нет данных</p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </>
                                                    :
                                                    <>
                                                        <div className="section-name">
                                                            <span>{item.PathRoadName}, {item.PathDescription}, протяжённость: {item.TotalLength && item.TotalLength?.toFixed(3)} км</span>
                                                        </div>
                                                        <div className="section-content">
                                                            <div className="distance">
                                                                <p><strong>Обследовано:</strong></p>
                                                                {Object.keys(measureTypesNames).map((measureType: any) => {
                                                                    if (item[`${measureType}Total`] !== null) {
                                                                        return (
                                                                            <p>{item[`${measureType}Total`]?.toFixed(3)} км</p>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <p>0 км</p>
                                                                        )
                                                                    }
                                                                })}
                                                            </div>
                                                            <div className="measure-type">
                                                                <p><strong>Из них в нормативе:</strong></p>
                                                                {Object.keys(measureTypesNames).map((key: any) => {
                                                                    return <p>{measureTypesNames[key]}</p>
                                                                })}
                                                                <p><strong>По всем показателям:</strong></p>
                                                            </div>
                                                            <div className="values">
                                                                {Object.keys(measureTypesNames).map((measureType: any) => {
                                                                    if (item[`${measureType}AdmissiblePercent`] !== null) {
                                                                        return (
                                                                            <div className="progress-bar-div">
                                                                                <Box sx={{ width: '100%' }}>
                                                                                    <LinearProgressWithLabel className="bar" value={item[`${measureType}AdmissiblePercent`]?.toFixed(1)} />
                                                                                </Box>
                                                                            </div>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <p>Нет данных</p>
                                                                        )
                                                                    }
                                                                })}
                                                                {item[`TotalAdmissiblePercent`] !== null
                                                                    ?
                                                                    <div className="progress-bar-div total-value">
                                                                        <Box sx={{ width: '100%' }}>
                                                                            <LinearProgressWithLabel className="bar" value={item[`TotalAdmissiblePercent`]?.toFixed(1)} />
                                                                        </Box>
                                                                    </div>
                                                                    :
                                                                    <p>Нет данных</p>
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        )
                                    })}
                                </>
                                :
                                <div className="no-path-normativities">
                                    Нет данных
                                </div>
                            }
                        </>
                    }
                </>
            }
        </>
    );
}

